<template>
  <v-layout row wrap>
    <v-flex xs4 class="pr-1" data-ui-component="Survey Count">
      <SummaryTile title="Surveys">
        {{ numberOfSurveys }}
        <v-icon>content_paste</v-icon>
      </SummaryTile>
    </v-flex>
    <v-flex xs4 class="px-1" data-ui-component="First Survey Date">
      <SummaryTile title="From">
        {{ firstSurveyDate }}
        <v-icon>event</v-icon>
      </SummaryTile>
    </v-flex>
    <v-flex xs4 class="pl-1" data-ui-component="Last Survey Date">
      <SummaryTile title="To">
        {{ lastSurveyDate }}
        <v-icon>event</v-icon>
      </SummaryTile>
    </v-flex>
  </v-layout>
</template>
<script>
  import {
    numberWithCommas,
  } from '@/helpers/numbers'
  import moment from 'moment'
  import {
    prettyDateFormat,
  } from '@/components/mixins/MomentUtil'
  import {
    min,
    max,
  } from 'date-fns'
  import SummaryTile from '@/components/MonitoringFeature/DataSources/generic/SummaryTile'

  export default {
    components: {
      SummaryTile,
    },
    props: {
      dataSource: {
        type: Object,
        required: true,
      },
    },
    computed: {
      surveys() {
        return this.dataSource.Surveys || []
      },
      surveyDates() {
        return this.surveys.map(x => x.SurveyDateTimeRaw)
      },
      numberOfSurveys() {
        return numberWithCommas(this.surveys.length)
      },
      firstSurveyDate() {
        var minDate = moment(min(...this.surveyDates))
        return minDate ? minDate.format(prettyDateFormat) : 'Not Available'
      },
      lastSurveyDate() {
        var maxDate = moment(max(...this.surveyDates))
        return maxDate ? maxDate.format(prettyDateFormat) : 'Not Available'
      },
    },
  }
</script>